import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { concat, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, switchMap, tap } from 'rxjs/operators';
import { Company } from 'src/app/entities/company';
import { CompanyService } from 'src/app/services/company.service';
import { ProcessService } from 'src/app/services/process.service';
import {SharedService} from '../../../services/sharedService';
import {ControlType} from '../../../entities/controlType';
import { filterEligibleControls } from '../../../utils/control-eligibility';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-new-process',
  templateUrl: './new-process.component.html',
  styleUrls: ['./new-process.component.css']
})
export class NewProcessComponent implements OnInit {

  companies$: Observable<Company[]>;
  companiesLoading = false;
  companiesInput$ = new Subject<string>();
  selectedCompany: any;

  allControlTypes: ControlType[] = [];
  controlTypes$: ControlType[] = [];
  controlTypesLoading = false;
  controlTypesInput$ = new Subject<string>();
  selectedControl: any;
  creating = false;
  minLengthTerm = 3;
  needSelectControl = false

  constructor(public modalRef: BsModalRef, private companyService: CompanyService, private processService: ProcessService,
    private sharedService: SharedService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.loadCompanies();
      this.processService.getControlTypeList('').subscribe(resp => {
        this.allControlTypes = resp;
        this.refreshControlTypes();
        if (localStorage.getItem("currentControlType")?.trim() && localStorage.getItem("currentControlTypeName")){
          this.selectedControl = {key: localStorage.getItem("currentControlType"), name: localStorage.getItem("currentControlTypeName")};
        }else{
          this.needSelectControl = true
        }
      });
  }

  loadCompanies() {
    this.companies$ = concat(
      of([]), // default items
      this.companiesInput$.pipe(
        filter(res => {
          return res !== null && res.length >= this.minLengthTerm
        }),
        distinctUntilChanged(),
        debounceTime(800),
        tap(() => this.companiesLoading = true),
        switchMap(term => {
          return this.getCompanies(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.companiesLoading = false)
          );
        })
      )
    );
  }

  getCompanies(term: string = null): Observable<any> {
    return this.companyService.getCompanyList(term)
      .pipe(map(resp => {
        if (resp.Error) {
          throwError(resp.Error);
        } else {
          return resp.map(resp => { resp.fullName = resp.company_name + ' ' + resp.tax_id; return resp; });
        }
      },
      )
      );
  }
  
  onCompanyChange(): void {
    this.refreshControlTypes();
    this.revalidateSelectedControl();
  }

  private refreshControlTypes(): void {
    // Until a company is selected there is no taxpayer context, so show every control type.
    // Once a company is chosen, filter by its eligibility (a selected company whose
    // taxpayerType is unknown still hides restricted controls — the no-leak case).
    this.controlTypes$ = this.selectedCompany
      ? filterEligibleControls(this.allControlTypes, this.selectedCompany?.taxpayerType)
      : this.allControlTypes;
  }

  private revalidateSelectedControl(): void {
    if (!this.selectedControl) {
      return;
    }
    const stillEligible = this.controlTypes$.some(ct => ct.key === this.selectedControl.key);
    if (!stillEligible) {
      // The previously selected (or localStorage-preselected) control is not allowed
      // for this taxpayer: clear it and force the user to pick from the filtered list.
      this.selectedControl = null;
      this.needSelectControl = true;
    }
  }

  onSubmit(): void {
    // Defense-in-depth: never submit a control the taxpayer is not eligible for,
    // regardless of how the company was set (e.g. if the (change) event did not fire).
    this.refreshControlTypes();
    this.revalidateSelectedControl();
    if (!this.selectedControl) {
      return;
    }
    this.spinner.show();
    this.creating = true;
    let process = {};
    process['team'] = {};
    process['company'] = {};
    process['type'] = this.selectedControl
    process['team']['id'] = localStorage.getItem('currentTeamId');
    process['team']['name'] = localStorage.getItem('currentTeamName');
    process['company']['id'] = this.selectedCompany.id;
    process['company']['name'] = this.selectedCompany.company_name;
    process['company']['tax_id'] = this.selectedCompany.tax_id;
    // process['type']['key'] = localStorage.getItem("currentControlType");
    // process['type']['name'] = localStorage.getItem("currentControlTypeName");
    this.processService.addProcess(process).pipe(
      finalize(() => {
        this.spinner.hide();
        this.creating = false;
      })
    ).subscribe({
      next: () => {
        this.modalRef.hide();
        this.sharedService.addProcess();
      }
    });
 
  }


}
